import { render, staticRenderFns } from "./svgApp.vue?vue&type=template&id=04e2f6a0&"
import script from "./svgApp.vue?vue&type=script&lang=js&"
export * from "./svgApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports